module.exports = __webpack_public_path__ + "img/labels.9c122d84.svg";